import LoadingAction from "@common/redux/actions/LoadingAction";
import LoginAction from "@common/redux/actions/LoginAction";
import CustomerFormAction from "@common/redux/actions/CustomerFormAction";

export const handleReset = (...functions) => {
  LoadingAction.set(true)
    .then(() => handleResetFunctions(...functions))
    .finally(() => LoadingAction.set(false));
};

export const handleResetFunctions = (...functions) => {
  // Execute each function in the order they were passed
  functions.forEach((fn) => {
    if (typeof fn === "function") {
      fn();
    }
  });
};

export const handleResetForDesktop = () => {
  LoginAction.dispatch({ isInReadMode: true });
  CustomerFormAction.dispatch({ formType: "" });
};
